import { useEffect, useRef } from 'react';

const POLL_INTERVAL_MS = 30_000;

export function useIdleTimer(timeoutMs: number, onTimeout: () => void): void {
  const lastActivityRef = useRef(Date.now());
  const onTimeoutRef = useRef(onTimeout);

  useEffect(() => {
    onTimeoutRef.current = onTimeout;
  }, [onTimeout]);

  useEffect(() => {
    lastActivityRef.current = Date.now();

    const resetActivity = () => {
      lastActivityRef.current = Date.now();
    };

    window.addEventListener('mousemove', resetActivity);
    window.addEventListener('keydown', resetActivity);
    window.addEventListener('click', resetActivity);

    const interval = setInterval(() => {
      if (Date.now() - lastActivityRef.current > timeoutMs) {
        onTimeoutRef.current();
      }
    }, POLL_INTERVAL_MS);

    return () => {
      clearInterval(interval);
      window.removeEventListener('mousemove', resetActivity);
      window.removeEventListener('keydown', resetActivity);
      window.removeEventListener('click', resetActivity);
    };
  }, [timeoutMs]);
}
